import { render, staticRenderFns } from "./setRoleName.vue?vue&type=template&id=f76be622&"
import script from "./setRoleName.vue?vue&type=script&lang=ts&"
export * from "./setRoleName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports